import HomePage from "pages/HomePage";
import SignInPage from "pages/SignInPage";
import SignUpPage from "pages/signup/SignUpPage";
import SignUpFormPage from "pages/signup/SignUpFormPage";
import ForgotPasswordPage from "pages/ForgotPasswordPage";
import ResetPasswordPage from "pages/ResetPasswordPage";
import VerifyEmailPage from "pages/VerifyEmailPage";
import RaisePage from "pages/RaisePage";
import OpportunitiesPage from "pages/OpportunitiesPage";
import HowItWorksPage from "pages/HowItWorksPage";
import FaqPage from "pages/FaqPage";
import TermsOfServicePage from "pages/TermsOfServicePage";
import PrivacyPolicyPage from "pages/PrivacyPolicyPage";
import DisclosuresPage from "pages/DisclosuresPage";
import RefundPolicyPage from "pages/RefundPolicyPage";
import InvestmentRisksPage from "pages/InvestmentRisksPage";
import InvestorAgreementPage from "pages/InvestorAgreementPage";
import ContactPage from "pages/ContactPage";
import CampaignDetailPage from "pages/CampaignDetailPage";
import RiskDisclosurePage from "pages/RiskDisclosurePage";
import DashboardPage from "pages/DashboardPage";
import MyInvestmentsPage from "pages/MyInvestmentsPage";
import {
  OfferingDocumentPage,
  InvestPage,
  InvestmentPaymentSuccessPage,
  InvestmentPaymentCancelPage,
  InvestmentPaymentFailedPage,
  INVESTMENT_PAYMENT_ROUTES,
  INVESTMENT_PAYMENT_LEGACY_ROUTES,
} from "investment";

/** Routes accessible without authentication. Add new entries here. */
export const publicRoutes = [
  { path: "/", Component: HomePage },
  { path: "/raise", Component: RaisePage },
  { path: "/opportunities", Component: OpportunitiesPage },
  { path: "/how-it-works", Component: HowItWorksPage },
  { path: "/faq", Component: FaqPage },
  { path: "/terms", Component: TermsOfServicePage },
  { path: "/privacy", Component: PrivacyPolicyPage },
  { path: "/disclosures", Component: DisclosuresPage },
  { path: "/refund-policy", Component: RefundPolicyPage },
  { path: "/risks", Component: InvestmentRisksPage },
  { path: "/investor-overview", Component: InvestorAgreementPage },
  { path: "/contact", Component: ContactPage },
  { path: "/campaign/:id", Component: CampaignDetailPage },
];

/** Auth pages are only for logged-out users. */
export const authRoutes = [
  { path: "/sign-in", Component: SignInPage },
  { path: "/sign-up", Component: SignUpPage },
  { path: "/sign-up/:type", Component: SignUpFormPage },
  { path: "/forgot-password", Component: ForgotPasswordPage },
];

/** Auth-flow pages that are accessible to both guests and authenticated users
 *  (e.g. someone may already be signed in when they click the verify-email
 *  link from their inbox). Rendered under AuthLayout without GuestRoute. */
export const publicAuthRoutes = [
  { path: "/verify-email", Component: VerifyEmailPage },
  { path: "/reset-password", Component: ResetPasswordPage },
];

/** Routes that require an authenticated session. Add new entries here. */
export const privateRoutes = [
  { path: "/dashboard", Component: DashboardPage },
  { path: "/my-investments", Component: MyInvestmentsPage },
  { path: "/risk-disclosure", Component: RiskDisclosurePage },
  { path: "/offering-document", Component: OfferingDocumentPage },
  { path: "/invest/:campaignId", Component: InvestPage },
  { path: INVESTMENT_PAYMENT_ROUTES.success, Component: InvestmentPaymentSuccessPage },
  { path: INVESTMENT_PAYMENT_ROUTES.cancel, Component: InvestmentPaymentCancelPage },
  { path: INVESTMENT_PAYMENT_ROUTES.failed, Component: InvestmentPaymentFailedPage },
  // API Stripe defaults (see INVESTMENT_PAYMENT_LEGACY_ROUTES)
  { path: INVESTMENT_PAYMENT_LEGACY_ROUTES.success, Component: InvestmentPaymentSuccessPage },
  { path: INVESTMENT_PAYMENT_LEGACY_ROUTES.cancel, Component: InvestmentPaymentCancelPage },
  { path: INVESTMENT_PAYMENT_LEGACY_ROUTES.failed, Component: InvestmentPaymentFailedPage },
];
